


<app-website-header></app-website-header>

<div class="container-fluid">

        <section class="about">
            <div class="row">
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 24px"></div>
            </div>


            <div class="row">
                <div class="col-sm-1"></div>

                <div class="about-image">
                    <p style="object-fit: contain;
                font-family: Raleway;
                font-size: 45px;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.33;
                letter-spacing: 0.32px;
                text-align: left;
                color: #ff6d11;">About Us</p>
                    <p style="margin-top:-33px;"><img src="assets/section-images/Path 336.png"> </p>
                </div>

                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 24px"></div>
            </div>
            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm-2" style="margin-left: -14px;">
                    <a href="what-are-we" class="services">
                        <p> <span style="font-weight: bolder;"> ></span> What Are We </p>
                    </a>
                    <a href="vision-mission" class="services">
                        <p style="color: #ff6d11;"><span style="font-weight: bolder;color: #ff6d11;"> > </span> Vision &
                            Mission </p>
                    </a>
                    <a href="strategic-changes" class="services">
                        <p> <span style="font-weight: bolder;"> ></span> Strategic changes </p>
                    </a>
                </div>


                <div class="col-sm-7" style="margin-left: 105px;">
                    <p style="font-family: Raleway;
                font-size: 24px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.21;
                letter-spacing: 0.24px;
                text-align: left;
                color: #ff6d11;">Vision</p>
                    <p style="object-fit: contain;
                font-family: Raleway;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.75;
                letter-spacing: 0.13px;
                text-align: left;
                color: #000000;">We wish to be the foremost Professional Tax Services Business Consulting firm with the
                        highest ethical standards that delivers exceptional value for our customers, our employees, our
                        communities and our partners with quality services and ongoing innovations across all spheres of
                        service. We will accomplish our Vision through our eternal commitment to strategic growth,
                        outstanding service, and community involvement.</p>

                    <br> <br>

                    <p style="font-family: Raleway;
                   font-size: 24px;
                   font-weight: 500;
                   font-stretch: normal;
                   font-style: normal;
                   line-height: 1.21;
                   letter-spacing: 0.24px;
                   text-align: left;
                   color: #ff6d11;">Mission</p>
                    <p style="object-fit: contain;
                   font-family: Raleway;
                   font-size: 16px;
                   font-weight: normal;
                   font-stretch: normal;
                   font-style: normal;
                   line-height: 1.75;
                   letter-spacing: 0.13px;
                   text-align: left;
                   color: #000000;">We wish to make consistent initiatives in enhancing our capabilities and to seek
                        ways to equip ourselves to achieve leadership status and relentlessly serve the ever increasing
                        needs of diversified customers by upgrading our technological infrastructure and quality of our
                        people.</p>

                </div>
                <div class="col-sm-2"></div>
            </div>

            <div class="row">
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 40px"></div>
            </div>



            <div class="row">
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 50px"></div>
            </div>


            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm-5">
                    <p class="need-help">NEED HELP?</p> <br>
                    <p class="need-content">
                        Contact our customer support team if you have any further questions. We are here to help you
                        out.
                    </p> <br>

                     <a href="tel:+1(737)637-6407">
                        <button class="btn  btn-sm Number" id="right" style="width: 250px;
                                    height: 50px;
                                    object-fit: contain;
                                    border-radius: 25px;
                                    background-color: #ff6d11;
                                    color: white;">
                        +1 (737) 637 - 6407 &nbsp;
                    </button>
                    </a>
                </div>

                <div class="col-sm-5">
                    <img src="assets/section-images/Group 1364.png">
                </div>

                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 65px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>
        </section>

    </div>

<app-website-footer></app-website-footer>